export class GetBatchUsageTrackingRequestModel {
  CustomerId?: number | null;
  FromDate?: string | null;
  ToDate?: string | null;
  DateRange?: string | null;
  SearchText?: string | null;
  SortColumn?: string | null;
  SortOrder?: string | null;
  PageNumber: number = 1;
  PageSize: number = 10;
}
